module.exports = __webpack_public_path__ + "img/green_070.31ac4579.png";